export enum FeedbackEvents {
	// modal events
	OpenFeedbackTemplateModal = 'open-feedback-template-modal',
}
